import { render, staticRenderFns } from "./XRayModal.vue?vue&type=template&id=855b7dc4&"
import script from "./XRayModal.vue?vue&type=script&lang=js&"
export * from "./XRayModal.vue?vue&type=script&lang=js&"
import style0 from "./XRayModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports